export default __webpack_public_path__ + "static/ig-7114b7b5efeea14db276e1fcd3dbd704.png";